import imagenondisponible from "./images/imagenondisponible.png";
import blurryImage from "./images/blurry.jpg";
export const PERSISTANCE_KEY = "FM-050";
export const TOUR_BUILDER_DEFAULT_NBR_DAYS = 4;
export const API_ENDPOINT =
  "https://staging-api-visitfesmeknes-com.cloud.marrakech.io";
export const DEV_API_ENDPOINT = "http://127.0.0.1:4040";
export const CDN_ENDPOINT = "https://d3lq8p6p6r1qxf.cloudfront.net";
export const USER_IP_ENDPOINT = "https://json.geoiplookup.io";
export const API_NEWSLETTER = API_ENDPOINT + "/newsletter";
export const API_CONTACT = API_ENDPOINT + "/contact";
export const RESIZE_URL = "https://imaginary.wakati.io/resize";

/**
 * Vote Endpoind Schema
 *
 * id: {
      type: String,
    },
    type: {
      type: Number, //circuit=03, place = 01, tour=02
    },
    like: {
      type: Boolean
    }
 */

export const API_VOTES = API_ENDPOINT + "/vote";
export const API_PLACES = API_ENDPOINT + "/cache/places";
export const API_MICE = API_ENDPOINT + "/mice";
export const API_QUOTES = API_ENDPOINT + "/quote";
export const API_ARTICLES = API_ENDPOINT + "/articles";
export const API_DEALS = API_ENDPOINT + "/cache/places?isDeal=true";
export const API_TAGS = API_ENDPOINT + "/tags";
export const API_CITIES = API_ENDPOINT + "/city";
export const API_CIRCUITS = API_ENDPOINT + "/circuits";
export const API_TOURS = API_ENDPOINT + "/tours";
export const API_STATS = API_ENDPOINT + "/cache/bi";
export const API_STORIES = API_ENDPOINT + "/stories";
export const API_INSTAWALL = API_ENDPOINT + "/instawall";
export const API_STATS_LIVE = API_ENDPOINT + "/bi";

export const API_UPLOAD = API_ENDPOINT + "/media";

export const CLOUDINARY =
  "https://cdn.visitbenimellal.ma/fetch/c_fit,g_center,h_600/";

export const MAPBOX_ACCESS_TOKEN = {
  accessToken:
    "pk.eyJ1IjoiY2FzYmFoZGV2IiwiYSI6ImNsZzU0NGZ4eDAxaDgzbm90N3doeG9lMXYifQ.N92Svf7rjH1NSKgn2k-R2w",
};

export const MAPBOX_STYLE_URL =
  "mapbox://styles/casbahdev/clg55cs3r003401o6xkm7274p";

// Map URL Constants (only links/URLs as global variables)
export const MAP_URLS = {
  // POI Map Style URL
  POI_MAP_STYLE: "mapbox://styles/casbahdev/clg55cs3r003401o6xkm7274p",

  // RTL Text Plugin URL
  RTL_TEXT_PLUGIN:
    "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js",
};

export const NO_IMAGE = imagenondisponible;
export const BLURRY_IMAGE = blurryImage;

export const YOUTUBE_CHANNEL_URL = "https://www.youtube.com/@CRTFesmeknes25";
//exclude from tripPlanner
export const TRIP_PLANNER_ARRAY = [
  "activite",
  "restaurant",
  "evenement",
  "transport",
  "hotel",
  "agence-de-voyages",
  "cafe",
  "packages",
  "visite-guidee",
  "hotel-connect",
  "circuit-decouvertes",
];

//exact main menu Tags
export const EXACT_MAIN_MENU_TAGS = [
  "lacs-et-barrages",
  "culture-et-vestiges",
  "espaces-naturels",
  "activites",
];

//exact deal tags
export const EXACT_DEAL_TAGS = [
  "hebergement-deal",
  "activite-deal",
  "sejour-deal",
  "restaurant-deal",
];

//exact trip planner tags
export const EXACT_TRIP_PLANNER_ARRAY = [
  "culture",
  "nature",
  "balneaire",
  "adrenaline",
  "activites-aquatiques",
  "activites-sportives",
];
export const cities1 = [
  {
    id: 486,
    name: "Sefrou",
    coordinates: [-4.83, 33.82],
  },
  {
    id: 158,
    name: "Ifrane",
    coordinates: [-5.12, 33.51],
  },
  {
    id: 2468,
    name: "Taounate",
    coordinates: [-4.64, 34.54],
  },
  {
    id: 3879,
    name: "Fes",
    coordinates: [-5.01, 34.02],
  },
  {
    id: 4498,
    name: "Boulmane",
    coordinates: [-4.72, 33.36],
  },
];
export const cities2 = [
  {
    id: 5849,
    name: "Meknès",
    coordinates: [-5.54, 33.87],
  },
  {
    id: 6549,
    name: "EL Hajeb",
    coordinates: [-5.37, 33.68],
  },
  { id: 4642, name: "Taza", coordinates: [-3.99, 34.22] },
  {
    id: 79797,
    name: "Moulay Yacoub",
    coordinates: [-5.17, 34.08],
  },
];
export const BROCAT_ARRAY = [
  "ligne de bus",
  "plan de development",
  "carte touristique",
  "catalogue",
];

export const BROCHURES_ARRAY = ["papiers", "électronique"];
export const EAT_ARRAY = ["restaurants"];

//todos arrays
export const TODO_ARRAY = ["activites"];

// See Tags
export const SEE_ARRAY = ["culture-et-vestiges", "espaces-naturels"];

export const ALL_ARRAY = [
  "culture-et-vestiges",
  "espaces-naturels",
  "activites-aquatiques",
  "activites",
  "restaurants",
];

export const FILTERS_ARRAY = [
  "culture-et-vestiges",
  "espaces-naturels",
  "activites",
  "lacs-et-barrages",
  "evenements",
];

//include to Explore menu
export const EXPLORE_ARRAY = [
  "espaces-naturels",
  "culture-et-vestiges",
  "lacs-et-barrages",
];

export const JSON_HEADERS = {
  Accept: "application/json, text/plain, */*",
  "Content-Type": "application/json",
};

export const filter =
  "linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 23.78%), radial-gradient(53.73% 53.73% at 42.09% 46.27%, rgba(0, 0, 0, 0.1) 60.43%, rgba(0, 0, 0, 0.2) 99.48%)";

export const SUPPORTED_LOCALS = {
  fr: "Français",
  es: "Español",
  en: "English",
  de: "Allemand",
};

export const DEFAULT_MAP_CENTER = [-5.01, 34.02];
export const DEFAULT_MAP_REGION = { longitude: -5.01, latitude: 34.02 };

export const SECTIONS_DEF = {
  story: "story",
  topExperience: "topExperience",
  regionMap: "regionMap",
  circuit: "circuit",
  regionMapMultiSelect: "regionMapMultiSelect",
  hoverMap: "hoverMap",
  storyEvent: "storyEvent",
  instaWall: "instaWall",
};

// External App URLs
export const EXTERNAL_APPS = {
  interactiveMap:
    "https://fes-meknes-interactive-map.vercel.app/create-program/trip-planer/1",
  inspiringMode: "https://fes-meknes-inspiring-mode.vercel.app/",
};

// Menu configuration for navigation components
export const MENU_CONFIG = {
  destinations: {
    titleKey: "destinations",
    items: [
      {
        labelKey: "fez",
        descriptionKey: "fesDescription",
        path: "/destination/fez",
      },
      {
        labelKey: "meknes",
        descriptionKey: "meknesDescription",
        path: "/destination/meknes",
      },
      {
        labelKey: "ifrane",
        descriptionKey: "ifraneDescription",
        path: "/destination/ifrane",
      },
      {
        labelKey: "azrou",
        descriptionKey: "azrouDescription",
        path: "/destination/azrou",
      },
      {
        labelKey: "immouzerKandar",
        descriptionKey: "immouzerKandarDescription",
        path: "/destination/immouzer",
      },
      {
        labelKey: "sefrou",
        descriptionKey: "sefrouDescription",
        path: "/destination/sefrou",
      },
      {
        labelKey: "moulayDrissZerhoun",
        descriptionKey: "moulayDrissZerhounDescription",
        path: "/destination/moulay-driss",
      },
      {
        labelKey: "volubilis",
        descriptionKey: "volubilisDescription",
        path: "/destination/volubilis",
      },
      {
        labelKey: "middleAtlas",
        descriptionKey: "middleAtlasDescription",
        path: "/destination/middle-atlas",
      },
    ],
  },
  thingsToDo: {
    titleKey: "thingsToDo",
    items: [
      {
        labelKey: "activities",
        descriptionKey: "activitiesDescription",
        path: "/discover/activities",
      },
      {
        labelKey: "cultureVestiges",
        descriptionKey: "cultureVestigesDescription",
        path: "/preference/3",
      },
      {
        labelKey: "naturalSpaces",
        descriptionKey: "naturalSpacesDescription",
        path: "/preference/5",
      },
      {
        labelKey: "lakesDams",
        descriptionKey: "lakesDamsDescription",
        path: "/preference/4",
      },
      {
        labelKey: "restaurants",
        descriptionKey: "restaurantsDescription",
        path: "/discover/restaurants",
      },
    ],
  },
  info: {
    titleKey: "info",
    items: [
      // {
      //   labelKey: "theRegion",
      //   descriptionKey: "theRegionDescription",
      //   path: "/region",
      // },
      {
        labelKey: "whoWeAre",
        descriptionKey: "whoWeAreDescription",
        path: "/about",
      },
      {
        labelKey: "mapsGuides",
        descriptionKey: "mapsGuidesDescription",
        path: "/mapsguides",
      },
      {
        labelKey: "helpMe",
        descriptionKey: "helpMeDescription",
        path: "/practical-info",
      },
    ],
  },
  plan: {
    titleKey: "plan",
    items: [
      {
        labelKey: "myItinerary",
        descriptionKey: "myItineraryDescription",
        path: "/my-itinerary",
        external: true,
        url: EXTERNAL_APPS.interactiveMap,
      },
      {
        labelKey: "hotels",
        descriptionKey: "hotelsDescription",
        path: "/discover/hotels",
      },
      {
        labelKey: "travelAgencies",
        descriptionKey: "travelAgenciesDescription",
        path: "/discover/travel-agencies",
      },
      {
        labelKey: "inspireMe",
        descriptionKey: "inspireMeDescription",
        path: "/inspire",
        external: true,
        url: EXTERNAL_APPS.inspiringMode,
      },
      // {
      //   labelKey: "imVisiting",
      //   descriptionKey: "imVisitingDescription",
      //   path: "/visiting",
      // },
    ],
  },
};

// Social media URLs
export const SOCIAL_MEDIA_URLS = {
  facebook:
    "https://www.facebook.com/people/Conseil-R%C3%A9gional-du-Tourisme-F%C3%A8s-Mekn%C3%A8s/61556848502704/?_rdr",
  instagram: "https://www.instagram.com/crtfesmeknes/?hl=fr",
  youtube: YOUTUBE_CHANNEL_URL,
};

// App Store URLs
export const APP_STORE_URLS = {
  appstore: "https://apps.apple.com/app/id123456789", // Replace with actual App Store URL
  googleplay:
    "https://play.google.com/store/apps/details?id=com.visitfesmeknes.application",
};

// Contact Information
export const CONTACT_INFO = {
  email: "crtfesmeknes2024@gmail.com",
  phone: "06 61 39 65 04",
  contactPath: "/contact",
};

// Agency Information
export const AGENCY_INFO = {
  website: "https://www.casbah.ma/",
};
